angular.module('callX').directive('maskInput', function() {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            var $self = elm;
            var _mask = $self.data('mask-format') ? $self.data('mask-format') : '##########';
            $self.inputmask(_mask);
        }
    };
});